import React from 'react';
import DownChevronIcon from '../../../../assets/images/svg/DownChevronIcon';
import { classNames } from '../../../utils';
import { getNumberOfPages } from '../utils';

interface DataPaginationProps {
  rowsPerPage: number;
  rowCount: number;
  currentPage: number;
  onChangePage: (page: number) => void;
  className?: string;
}

function DataPagination({
  rowsPerPage,
  rowCount,
  currentPage,
  onChangePage,
  className,
}: DataPaginationProps): JSX.Element {
  const numPages = getNumberOfPages(rowCount, rowsPerPage);
  const disableNext = currentPage === numPages;
  const disablePrev = currentPage === 1;

  const handlePrevious = React.useCallback(
    () => onChangePage(currentPage - 1),
    [currentPage, onChangePage],
  );
  const handleNext = React.useCallback(() => onChangePage(currentPage + 1), [
    currentPage,
    onChangePage,
  ]);

  return (
    <div
      className={classNames(
        className ? className : 'border-t border-gray-light px-8 py-5',
      )}
    >
      <nav
        className='flex flex-row justify-between items-center box-border  w-full'
        style={{ flex: '1 1 auto' }}
      >
        <div className='flex items-center rounded whitespace-nowrap'>
          <button
            type='button'
            aria-disabled={disablePrev}
            disabled={disablePrev}
            className={`relative flex items-center focus:outline-none justify-center rounded select-none w-9 h-9 border border-gray-light ${
              disablePrev
                ? 'text-gray bg-white cursor-default text-opacity-50 border-opacity-50'
                : 'text-gray hover:text-gray-dark hover:bg-gray-lightest cursor-pointer'
            }`}
            onClick={handlePrevious}
          >
            <span className='block transform rotate-90'>
              <DownChevronIcon width='24' height='24' strokeWidth='3' />
            </span>
          </button>
          <button
            type='button'
            aria-disabled={disableNext}
            disabled={disableNext}
            className={`relative flex focus:outline-none justify-center items-center rounded select-none w-9 h-9 border border-gray-light ${
              disableNext
                ? 'text-gray bg-white cursor-default text-opacity-50 border-opacity-50'
                : 'text-gray hover:text-gray-dark hover:bg-gray-lightest cursor-pointer'
            }`}
            onClick={handleNext}
          >
            <span className='block transform -rotate-90 '>
              <DownChevronIcon width='24' height='24' strokeWidth='3' />
            </span>
          </button>
        </div>
        <div>
          <h3 className='text-gray font-medium tracking-tight'>
            Page {currentPage} of {numPages}
          </h3>
        </div>
      </nav>
    </div>
  );
}

export default DataPagination;
